import { render, staticRenderFns } from "./FieldBranch.vue?vue&type=template&id=7d4c87f4&scoped=true"
import script from "./FieldBranch.vue?vue&type=script&lang=js"
export * from "./FieldBranch.vue?vue&type=script&lang=js"
import style0 from "./FieldBranch.vue?vue&type=style&index=0&id=7d4c87f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c87f4",
  null
  
)

export default component.exports